<template>
  <div class="updateDecisonTree">
    <main class="t-main">
    <ol class="m-breadcrumb">
      <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/udata/list-decision-tree">決定木一覧</router-link></li>
      <li class="m-breadcrumb__item"><span class="a-text">決定木編集</span></li>
    </ol>
   <h1 class="a-title">{{ updateDecisionTreeTitle }}</h1>
   <div class="m-form__item-wrapper">
     <div class="m-form__item m-form__item--50">
       <label class="m-form__label">treeId<span class="m-form__label--necessary">※必須</span>
         <input class="m-form__input m-form__input--text" type="text"　v-model="tasks.treeId" placeholder="treeIdを入力してください">
       </label>
     </div>
   </div>
   <div class="m-form__item-wrapper">
     <div class="m-form__item m-form__item--50">
       <label class="m-form__label">タイトル<span class="m-form__label--necessary">※必須</span>
         <input class="m-form__input m-form__input--text" type="text" placeholder="タイトルを入力してください。" v-model="tasks.name">
       </label>
     </div>
   </div>
   <div class="m-form__item-wrapper">
     <div class="m-form__item m-form__item--50">
       <input class="m-form__input m-form__input--text" type="file" @change="onFileChange">
     </div>
   </div>
   <p class="a-button__wrapper">
     <button class="a-button" v-on:click="updateDecisionTree">更新</button>
     <button class="a-button a-button--cansel" v-on:click="goListDecisionTree">キャンセル</button>
   </p>
 </main>
  </div>
 </template>

<script>
import store from '../../../stores'
import { treeIdRegexp, nameRegexp, modelRegexp } from '../../../constants'

export default {
  name: 'updateDecisonTree',
  data() {
    return { updateDecisionTreeTitle: '決定木編集' }
  },
  created() {
    store.state.decisiontree.datasourceId = this.$route.query.datasourceId
    this.tasks.treeId = this.$route.query.treeId
    store.dispatch('getDecisiontreeData')
  },
  computed: {
    tasks: { get() {
      return store.state.decisiontree.decisiontree
    } },
    // バリデーション関数を定義する
    upValidation: function () {
      return {
        treeId: treeIdRegexp.test(this.tasks.treeId),
        name: nameRegexp.test(this.tasks.name),
        model: modelRegexp.test(this.tasks.model)
      }
    },
    // バリデーションを読み込む関数
    isUpValid: function () {
      let msg = []
      if (this.tasks.treeId == null || this.tasks.treeId === '') {
        msg.push('treeIdは必須です')
      } else if (this.upValidation.treeId === false) {
        msg.push('入力項目(treeId)に不備があります')
      }
      if (this.tasks.name == null || this.tasks.name === '') {
        msg.push('タイトルは必須です')
      } else if (this.upValidation.name === false) {
        msg.push('入力項目(タイトル)に不備があります')
      }
      if (this.tasks.model == null || this.tasks.model === '') {
        msg.push('ファイルは必須です')
      } else if (this.upValidation.model === false) {
        msg.push('入力項目(ファイル)に不備があります')
      }
      return msg.join('\n')
    }
  },
  methods: {
    callDecisionTree: function() { store.dispatch('decisiontree', this.tasks) },
    updateDecisionTree: function() {
      var errMsg = this.isUpValid
      if (errMsg === '') {
        store.dispatch('updateDecisionTree', this.$router)
      } else {
        alert(errMsg)
      }
    },
    goListDecisionTree: function() {
      this.$router.push('/udata/list-decision-tree')
    },
    onFileChange: function(e) {
      let files = e.target.files || e.dataTransfer.files
      if (files) {
        // base64に変換する
        let fileReader = new FileReader()
        fileReader.onload = function() {
          store.state.decisiontree.decisiontree.model = this.result.split(',')[1]
        }
        fileReader.readAsDataURL(files[0])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/udata/decisiontree/UpdateDecisionTree.vue